module.exports = __webpack_public_path__ + "static/img/MW.b946c2bc.svg";